import { GET_SUMMARY, GET_DETAIL } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GET_SUMMARY:
      return Object.assign({}, state, { summaryList: action.payload })
    case GET_DETAIL:
      return Object.assign({}, state, { detailList: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/TableUsageStatistics/reduce.js